// removed by extract-text-webpack-plugin
module.exports = {"preview":"navigation-element-options__preview___3zzwC","menu-item":"navigation-element-options__menu-item___2PkaS","menuItem":"navigation-element-options__menu-item___2PkaS","accent":"navigation-element-options__accent___2QNeX","text":"navigation-element-options__text___1MDOy"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/navigation-element-options.css
// module id = 784
// module chunks = 0